import { render, staticRenderFns } from "./FindSomethingElse.vue?vue&type=template&id=3d52700c"
import script from "./FindSomethingElse.vue?vue&type=script&lang=js"
export * from "./FindSomethingElse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports